// extracted by mini-css-extract-plugin
export default {"tableContainer":"FrontendDataTable_tableContainer__xJHzp","tableScroll":"FrontendDataTable_tableScroll__W9FnM","table":"FrontendDataTable_table__3ro4u"};